(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zoda-product-main"] && !Shopify.designMode) return;
  try {
    
(() => {
  const zodaPdpReviewNodeCache = new WeakMap();
  const zodaPdpReviewUiState = new WeakMap();
  const ZODA_PDP_REVIEW_PAGE_SIZE = 5;
  const ZODA_PDP_REVIEW_SORT_OPTIONS = [
    { value: "most-recent", label: "Most Recent" },
    { value: "highest-rating", label: "Highest Rating" },
    { value: "lowest-rating", label: "Lowest Rating" },
    { value: "only-pictures", label: "Only Pictures" },
    { value: "pictures-first", label: "Pictures First" },
    { value: "videos-first", label: "Videos First" },
    { value: "most-helpful", label: "Most Helpful" },
  ];

  const renderProductReviewFallbacks = () => {
    document.querySelectorAll("[data-zoda-pdp-judgeme-section]").forEach((reviewSection) => {
      const nativeWidget = reviewSection.querySelector("[data-zoda-pdp-judgeme-native]");
      const fallback = reviewSection.querySelector("[data-zoda-pdp-review-fallback]");
      const source = nativeWidget?.querySelector(".jdgm-legacy-widget-content .jdgm-rev-widg, .jdgm-rev-widg");
      const reviewStub = document.querySelector("[data-zoda-pdp-review-stub]");
      const nativeBadge = reviewStub?.querySelector("[data-zoda-pdp-review-badge]");
      const summaryFallback = reviewStub?.querySelector("[data-zoda-pdp-review-summary]");
      const reviewFilter = reviewSection.querySelector("[data-zoda-pdp-review-filter]");
      const reviewControls = reviewSection.querySelector("[data-zoda-pdp-review-controls]");
      const writeReviewButton = reviewSection.querySelector("[data-zoda-pdp-review-write]");
      const overview = reviewSection.querySelector("[data-zoda-pdp-review-overview]");
      const overviewStars = reviewSection.querySelector("[data-zoda-pdp-review-overview-stars]");
      const overviewScore = reviewSection.querySelector("[data-zoda-pdp-review-overview-score]");
      const overviewCount = reviewSection.querySelector("[data-zoda-pdp-review-overview-count]");
      const overviewBars = reviewSection.querySelector("[data-zoda-pdp-review-overview-bars]");

      if (!nativeWidget || !fallback || !source) return;

      const setNativeWidgetState = (state) => {
        nativeWidget.hidden = false;
        nativeWidget.style.display = "";
        nativeWidget.removeAttribute("aria-hidden");
        nativeWidget.dataset.zodaPdpNativeState = state;

        if (state === "open") {
          nativeWidget.dataset.zodaPdpReviewFormOpen = "true";
          document.documentElement.classList.add("zoda-pdp-review-modal-open");
          document.body?.classList.add("zoda-pdp-review-modal-open");
          return;
        }

        nativeWidget.removeAttribute("data-zoda-pdp-review-form-open");
        document.documentElement.classList.remove("zoda-pdp-review-modal-open");
        document.body?.classList.remove("zoda-pdp-review-modal-open");
      };
      const normalize = (value) => String(value || "").replace(/\s+/g, " ").trim();
      const getVisibleReviewNodes = (root) =>
        [...(root?.querySelectorAll(".jdgm-rev") || [])].filter((review) =>
          normalize(review.querySelector(".jdgm-rev__body")?.textContent)
        );
      const getReviewKey = (review) => {
        const reviewId = review.dataset.reviewId || review.getAttribute("data-review-id");
        if (reviewId) return `id:${reviewId}`;

        return [
          normalize(review.querySelector(".jdgm-rev__author")?.textContent),
          normalize(review.querySelector(".jdgm-rev__body")?.textContent),
          normalize(review.querySelector(".jdgm-rev__timestamp")?.dataset.content),
          normalize(review.querySelector(".jdgm-rev__rating")?.dataset.score),
        ].join("|");
      };
      const parseReviewNodesFromHtml = (html) => {
        const template = document.createElement("template");
        template.innerHTML = html || "";
        return getVisibleReviewNodes(template.content);
      };
      const injectReviewSchema = (nodes, count, average) => {
        if (!count || !nodes.length) return;

        const productUrl = window.location.href.split("?")[0];
        const reviews = nodes
          .map((review) => {
            const body = normalize(review.querySelector(".jdgm-rev__body")?.textContent);
            const author = normalize(review.querySelector(".jdgm-rev__author")?.textContent);
            const rating = Number(review.querySelector(".jdgm-rev__rating")?.dataset.score || 0);

            if (!body || !author || !rating) return null;

            return {
              "@type": "Review",
              author: { "@type": "Person", name: author },
              reviewRating: {
                "@type": "Rating",
                ratingValue: String(rating),
                bestRating: "5",
                worstRating: "1",
              },
              reviewBody: body,
            };
          })
          .filter(Boolean);

        if (!reviews.length) return;

        const schema = {
          "@context": "https://schema.org/",
          "@type": "Product",
          "@id": `${productUrl}#product`,
          name: normalize(nativeWidget.dataset.productTitle) || document.title,
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: String(average || 5),
            reviewCount: String(count),
            bestRating: "5",
            worstRating: "1",
          },
          review: reviews,
        };

        let scriptTag = document.querySelector('script[data-zoda-pdp-review-schema="true"]');
        if (!scriptTag) {
          scriptTag = document.createElement("script");
          scriptTag.type = "application/ld+json";
          scriptTag.dataset.zodaPdpReviewSchema = "true";
          document.head.appendChild(scriptTag);
        }
        scriptTag.textContent = JSON.stringify(schema);
      };
      const getJudgeMeShopDomain = () =>
        normalize(window.jdgm?.shopDomain?.()) ||
        normalize(window.Shopify?.shop) ||
        normalize(window.location.hostname) ||
        normalize(document.domain);
      const buildJudgeMeReviewPageUrl = (page) => {
        const paginate = source.querySelector(".jdgm-paginate");
        const endpoint = paginate?.dataset.url;
        const productId = nativeWidget.dataset.productId || nativeWidget.dataset.id;
        const shopDomain = getJudgeMeShopDomain();

        if (!endpoint || !productId || !shopDomain) return null;

        const url = new URL(endpoint, window.location.origin);
        let judgeMeParams = {};

        if (window.jdgm?.ajaxParamsFor && window.jdgm?.$) {
          try {
            judgeMeParams = window.jdgm.ajaxParamsFor(window.jdgm.$(nativeWidget)) || {};
          } catch (error) {
            judgeMeParams = {};
          }
        }

        const updatedAt = source.dataset.updatedAt;
        const shouldUseCacheTimestamp = Boolean(window.jdgmSettings?.enable_ajax_cdn_cache && updatedAt);
        const fallbackParams = {
          url: shopDomain,
          shop_domain: shopDomain,
          platform: window.jdgmSettings?.platform || "shopify",
          per_page: Number(paginate?.dataset.perPage || 5),
          product_id: productId,
          sort_by: nativeWidget.dataset.sortBy || null,
          sort_dir: nativeWidget.dataset.sortDir || null,
          filter_rating: nativeWidget.dataset.filterRating || null,
          ts: shouldUseCacheTimestamp ? parseInt(Date.parse(updatedAt) / 1000, 10) : null,
        };
        const params = { ...fallbackParams, ...judgeMeParams, page };

        Object.entries(params).forEach(([key, value]) => {
          if (value === null || value === undefined || value === "") return;
          url.searchParams.set(key, value);
        });

        return url;
      };
      const fetchJudgeMeReviewPage = async (page) => {
        if (!window.fetch) return [];

        const url = buildJudgeMeReviewPageUrl(page);
        if (!url) return [];

        try {
          const response = await window.fetch(url.toString(), {
            credentials: "omit",
            headers: { accept: "application/json" },
          });

          if (!response.ok) return [];

          const data = await response.json();
          return parseReviewNodesFromHtml(data?.html || "");
        } catch (error) {
          return [];
        }
      };
      const collectAllReviewNodes = (initialReviewNodes, reviewCount) => {
        if (zodaPdpReviewNodeCache.has(nativeWidget)) return zodaPdpReviewNodeCache.get(nativeWidget);

        const promise = (async () => {
          const allReviewNodes = [...initialReviewNodes];
          const seenReviewKeys = new Set(allReviewNodes.map(getReviewKey));
          const paginate = source.querySelector(".jdgm-paginate");
          const perPage = Math.max(1, Number(paginate?.dataset.perPage || initialReviewNodes.length || 5));
          const visiblePages = [...(paginate?.querySelectorAll("[data-page]") || [])]
            .map((link) => Number(link.getAttribute("data-page") || 0))
            .filter((page) => page > 1);
          const maxPage = Math.max(Math.ceil(reviewCount / perPage), ...visiblePages, 1);
          const pages = [];

          for (let page = 2; page <= maxPage; page += 1) pages.push(page);

          const pageResults = await Promise.all(pages.map(fetchJudgeMeReviewPage));
          pageResults.flat().forEach((review) => {
            const key = getReviewKey(review);
            if (!key || seenReviewKeys.has(key)) return;
            seenReviewKeys.add(key);
            allReviewNodes.push(review);
          });

          return allReviewNodes;
        })();

        zodaPdpReviewNodeCache.set(nativeWidget, promise);
        return promise;
      };
      const getReviewUiState = () => {
        let state = zodaPdpReviewUiState.get(reviewSection);
        if (!state) {
          state = { page: 1, rating: 0, reviews: [], sort: "most-recent" };
          zodaPdpReviewUiState.set(reviewSection, state);
        }

        return state;
      };
      const getFilteredReviewNodes = (reviews, rating) => {
        const targetRating = Number(rating) || 0;
        if (!targetRating) return reviews;

        return reviews.filter((review) => Math.round(getReviewRating(review)) === targetRating);
      };
      const getRatingFilterCounts = (reviews) => {
        const counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };

        reviews.forEach((review) => {
          const rating = Math.round(getReviewRating(review));
          if (rating >= 1 && rating <= 5) counts[rating] += 1;
        });

        return counts;
      };
      const getReviewTimestamp = (review) => {
        const timestamp = review.querySelector(".jdgm-rev__timestamp");
        const rawValue = timestamp?.dataset.content || timestamp?.getAttribute("datetime") || timestamp?.textContent || "";
        const parsedTime = Date.parse(rawValue);

        return Number.isNaN(parsedTime) ? 0 : parsedTime;
      };
      const getReviewHelpfulScore = (review) => {
        const helpfulNode = review.querySelector(".jdgm-rev__votes, .jdgm-rev__vote, .jdgm-rev__helpful, .jdgm-rev__thumb-count");
        const helpfulText = normalize(helpfulNode?.textContent);

        return Number(helpfulNode?.dataset.count || helpfulText.match(/\d+/)?.[0] || 0);
      };
      const reviewHasPictures = (review) =>
        Boolean(review.querySelector(".jdgm-rev__pic-img, .jdgm-rev__pic, .jdgm-rev__pics img"));
      const reviewHasVideos = (review) =>
        Boolean(review.querySelector(".jdgm-rev__video, .jdgm-rev__vid, video, iframe, [data-video]"));
      const isVerifiedReview = (review) =>
        review.dataset.verifiedBuyer === "true" || Boolean(review.querySelector(".jdgm-rev__buyer-badge, .jdgm-rev__verified-badge"));
      const sortReviewNodes = (reviews, sortValue) => {
        const entries = reviews.map((review, index) => ({ review, index }));
        const byVerified = (a, b) => Number(isVerifiedReview(b.review)) - Number(isVerifiedReview(a.review));
        const byRecent = (a, b) => getReviewTimestamp(b.review) - getReviewTimestamp(a.review) || a.index - b.index;

        if (sortValue === "only-pictures") {
          return entries.filter((entry) => reviewHasPictures(entry.review)).sort((a, b) => byVerified(a, b) || byRecent(a, b)).map((entry) => entry.review);
        }

        entries.sort((a, b) => {
          const verifiedSort = byVerified(a, b);
          if (verifiedSort) return verifiedSort;

          if (sortValue === "highest-rating") {
            return getReviewRating(b.review) - getReviewRating(a.review) || byRecent(a, b);
          }

          if (sortValue === "lowest-rating") {
            return getReviewRating(a.review) - getReviewRating(b.review) || byRecent(a, b);
          }

          if (sortValue === "pictures-first") {
            return Number(reviewHasPictures(b.review)) - Number(reviewHasPictures(a.review)) || byRecent(a, b);
          }

          if (sortValue === "videos-first") {
            return Number(reviewHasVideos(b.review)) - Number(reviewHasVideos(a.review)) || byRecent(a, b);
          }

          if (sortValue === "most-helpful") {
            return getReviewHelpfulScore(b.review) - getReviewHelpfulScore(a.review) || byRecent(a, b);
          }

          return byRecent(a, b);
        });

        return entries.map((entry) => entry.review);
      };
      const scrollReviewStackIntoView = () => {
        const stack = reviewSection.querySelector("[data-zoda-pdp-review-stack]");
        if (stack instanceof HTMLElement) {
          stack.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      };
      const closeNativeReviewForm = () => {
        const formWrapper = nativeWidget.querySelector(".jdgm-form-wrapper");
        setNativeWidgetState("closed");
        if (formWrapper instanceof HTMLElement) formWrapper.style.display = "none";
      };
      const ensureNativeReviewCloseButton = () => {
        const legacyWrapper = nativeWidget.querySelector(".jdgm-legacy-widget-content");
        if (!(legacyWrapper instanceof HTMLElement)) return;

        let closeButton = legacyWrapper.querySelector("[data-zoda-pdp-review-modal-close]");
        if (closeButton instanceof HTMLElement) return;

        closeButton = document.createElement("button");
        closeButton.type = "button";
        closeButton.className = "zoda-pdp__review-modal-close";
        closeButton.dataset.zodaPdpReviewModalClose = "true";
        closeButton.setAttribute("aria-label", "Close review form");
        closeButton.textContent = "X";
        closeButton.addEventListener("click", closeNativeReviewForm);
        legacyWrapper.prepend(closeButton);
      };
      if (nativeWidget.dataset.zodaPdpReviewModalReady !== "true") {
        nativeWidget.dataset.zodaPdpReviewModalReady = "true";
        nativeWidget.addEventListener("click", (event) => {
          if (event.target === nativeWidget && nativeWidget.dataset.zodaPdpReviewFormOpen === "true") {
            closeNativeReviewForm();
          }
        });
        document.addEventListener("keydown", (event) => {
          if (event.key === "Escape" && nativeWidget.dataset.zodaPdpReviewFormOpen === "true") {
            closeNativeReviewForm();
          }
        });
      }
      const renderReviewFilterControls = (reviews) => {
        if (!reviewFilter) return;

        const state = getReviewUiState();
        const counts = getRatingFilterCounts(reviews);
        reviewFilter.hidden = !reviews.length;
        reviewFilter.innerHTML = "";

        if (!reviews.length) return;

        const activeSort = ZODA_PDP_REVIEW_SORT_OPTIONS.find((option) => option.value === state.sort) || ZODA_PDP_REVIEW_SORT_OPTIONS[0];
        const sort = document.createElement("details");
        sort.className = "zoda-pdp__review-sort";

        const summary = document.createElement("summary");
        summary.className = "zoda-pdp__review-sort-toggle";
        summary.textContent = activeSort.label;
        sort.appendChild(summary);

        const menu = document.createElement("div");
        menu.className = "zoda-pdp__review-sort-menu";

        ZODA_PDP_REVIEW_SORT_OPTIONS.forEach((option) => {
          const optionButton = document.createElement("button");
          optionButton.type = "button";
          optionButton.className = "zoda-pdp__review-sort-option";
          optionButton.setAttribute("aria-pressed", activeSort.value === option.value ? "true" : "false");
          optionButton.textContent = option.label;

          optionButton.addEventListener("click", () => {
            const currentState = getReviewUiState();
            currentState.sort = option.value;
            currentState.page = 1;
            sort.open = false;
            renderReviewCards(currentState.reviews || reviews);
            scrollReviewStackIntoView();
          });

          menu.appendChild(optionButton);
        });

        sort.appendChild(menu);
        reviewFilter.appendChild(sort);

        [0, 5, 4, 3, 2, 1].forEach((rating) => {
          const count = rating ? counts[rating] || 0 : reviews.length;
          if (rating && !count) return;

          const button = document.createElement("button");
          button.type = "button";
          button.className = "zoda-pdp__review-filter-button";
          button.dataset.zodaPdpReviewFilter = String(rating);
          button.setAttribute("aria-pressed", state.rating === rating ? "true" : "false");
          button.textContent = rating ? `${rating} star${rating === 1 ? "" : "s"} (${count})` : `All (${count})`;

          button.addEventListener("click", () => {
            const currentState = getReviewUiState();
            currentState.rating = rating;
            currentState.page = 1;
            renderReviewCards(currentState.reviews || reviews);
            scrollReviewStackIntoView();
          });

          reviewFilter.appendChild(button);
        });
      };
      const renderReviewPagination = (totalPages, currentPage, totalFiltered) => {
        if (!reviewControls) return;

        reviewControls.innerHTML = "";
        reviewControls.hidden = totalPages <= 1;

        if (totalPages <= 1) return;

        const createPageButton = (label, page, options = {}) => {
          const button = document.createElement("button");
          button.type = "button";
          button.className = "zoda-pdp__review-page-button";
          button.textContent = label;
          button.disabled = Boolean(options.disabled);

          if (options.current) {
            button.setAttribute("aria-current", "page");
          }

          button.addEventListener("click", () => {
            if (button.disabled) return;

            const state = getReviewUiState();
            state.page = page;
            renderReviewCards(state.reviews || []);
            scrollReviewStackIntoView();
          });

          return button;
        };

        reviewControls.appendChild(
          createPageButton("Prev", Math.max(1, currentPage - 1), { disabled: currentPage <= 1 })
        );

        for (let page = 1; page <= totalPages; page += 1) {
          reviewControls.appendChild(createPageButton(String(page), page, { current: page === currentPage }));
        }

        reviewControls.appendChild(
          createPageButton("Next", Math.min(totalPages, currentPage + 1), { disabled: currentPage >= totalPages })
        );

        const status = document.createElement("span");
        status.className = "zoda-pdp__review-page-status";
        status.textContent = `${totalFiltered} ${totalFiltered === 1 ? "review" : "reviews"}`;
        reviewControls.appendChild(status);
      };
      const revealNativeReviewForm = () => {
        setNativeWidgetState("open");

        const legacyWrapper = nativeWidget.querySelector(".jdgm-legacy-widget-content");
        if (legacyWrapper instanceof HTMLElement) {
          legacyWrapper.hidden = false;
          legacyWrapper.style.display = "block";
        }
        ensureNativeReviewCloseButton();

        nativeWidget.querySelectorAll(".jdgm-temp-hiding-style").forEach((styleNode) => {
          styleNode.remove();
        });

        const reviewWidget = nativeWidget.querySelector(".jdgm-rev-widg");
        if (reviewWidget instanceof HTMLElement) {
          reviewWidget.hidden = false;
          reviewWidget.style.display = "block";
        }

        const openFormWrapper = () => {
          const formWrapper = nativeWidget.querySelector(".jdgm-form-wrapper");
          if (formWrapper instanceof HTMLElement) {
            formWrapper.hidden = false;
            formWrapper.style.display = "block";
            formWrapper.removeAttribute("aria-hidden");
          }

          const removeReviewTitleField = () => {
            const reviewTitleField = nativeWidget.querySelector("input[name='review_title']")?.closest(".jdgm-form__fieldset");
            if (reviewTitleField instanceof HTMLElement) reviewTitleField.remove();
          };

          removeReviewTitleField();
          window.setTimeout(removeReviewTitleField, 300);
          window.setTimeout(removeReviewTitleField, 900);

          nativeWidget.querySelectorAll(".jdgm-cancel-rev").forEach((cancelButton) => {
            if (!(cancelButton instanceof HTMLElement) || cancelButton.dataset.zodaPdpCancelReady === "true") return;
            cancelButton.dataset.zodaPdpCancelReady = "true";
            cancelButton.addEventListener("click", closeNativeReviewForm);
          });
        };

        window.requestAnimationFrame(() => {
          const judgeMe = window.jdgm;
          ["loadWidgets", "renderWidgets", "initializeWidgets"].some((methodName) => {
            if (typeof judgeMe?.[methodName] !== "function") return false;
            judgeMe[methodName]();
            return true;
          });

          const writeButton = nativeWidget.querySelector(".jdgm-write-rev-link");
          if (writeButton instanceof HTMLElement) {
            writeButton.hidden = false;
            writeButton.style.display = "";
            writeButton.click();
          }

          openFormWrapper();
          ensureNativeReviewCloseButton();
          window.setTimeout(openFormWrapper, 120);
          window.setTimeout(ensureNativeReviewCloseButton, 120);
          window.setTimeout(() => {
            const focusTarget = nativeWidget.querySelector(".jdgm-form-wrapper textarea, .jdgm-form-wrapper input:not([type='hidden']), .jdgm-form-wrapper select");
            if (focusTarget instanceof HTMLElement) focusTarget.focus({ preventScroll: true });
          }, 160);
        });
      };
      if (writeReviewButton instanceof HTMLElement && writeReviewButton.dataset.zodaPdpReviewWriteReady !== "true") {
        writeReviewButton.dataset.zodaPdpReviewWriteReady = "true";
        writeReviewButton.addEventListener("click", revealNativeReviewForm);
      }

      if (window.location.search.includes("zoda_write_review=1")) {
        window.setTimeout(() => {
          reviewSection.scrollIntoView({ block: "start", behavior: "smooth" });
          revealNativeReviewForm();
        }, 700);
      }
      const renderStarIcons = (container, rating) => {
        if (!container) return;
        container.innerHTML = "";
        const roundedRating = Math.round(Number(rating) || 0);

        for (let index = 1; index <= 5; index += 1) {
          const star = document.createElement("span");
          star.className = index <= roundedRating ? "is-filled" : "";
          star.textContent = "\u2605";
          container.appendChild(star);
        }
      };
      const getReviewRating = (review) => Number(review.querySelector(".jdgm-rev__rating")?.dataset.score || 0);
      const getRatingCounts = (ratingReviewNodes) => {
        const counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
        const histogramRows = [...source.querySelectorAll(".jdgm-histogram__row")];

        histogramRows.forEach((row) => {
          const rowText = normalize(row.textContent);
          const rating = Number(row.dataset.rating || row.getAttribute("data-rating") || rowText.match(/[1-5]/)?.[0] || 0);
          const frequencyText = normalize(row.querySelector(".jdgm-histogram__frequency, .jdgm-histogram__count")?.textContent);
          const count = Number(frequencyText.match(/\d+/)?.[0] || 0);

          if (rating >= 1 && rating <= 5 && count >= 0) counts[rating] = count;
        });

        const histogramTotal = Object.values(counts).reduce((total, count) => total + count, 0);
        if (histogramTotal) return counts;

        ratingReviewNodes.forEach((review) => {
          const rating = Math.round(getReviewRating(review));
          if (rating >= 1 && rating <= 5) counts[rating] += 1;
        });

        return counts;
      };
      const renderOverview = (reviewCount, averageRating, ratingCounts) => {
        if (!overview) return;

        overview.hidden = false;
        renderStarIcons(overviewStars, averageRating || 0);

        if (overviewScore) {
          overviewScore.textContent = reviewCount ? `${(averageRating || 0).toFixed(1)} out of 5` : "No reviews yet";
        }

        if (overviewCount) {
          overviewCount.textContent = reviewCount
            ? `Based on ${reviewCount} ${reviewCount === 1 ? "review" : "reviews"}`
            : "Be the first to write a review";
        }

        if (!overviewBars) return;
        overviewBars.innerHTML = "";

        for (let rating = 5; rating >= 1; rating -= 1) {
          const count = ratingCounts?.[rating] || 0;
          const percentage = reviewCount ? Math.min((count / reviewCount) * 100, 100) : 0;
          const row = document.createElement("div");
          row.className = "zoda-pdp__review-overview-bar";
          row.setAttribute("aria-label", `${rating} star reviews: ${count}`);

          const rowStars = document.createElement("div");
          rowStars.className = "zoda-pdp__review-overview-bar-stars";
          renderStarIcons(rowStars, rating);

          const track = document.createElement("div");
          track.className = "zoda-pdp__review-overview-track";

          const fill = document.createElement("span");
          fill.style.width = `${percentage}%`;
          track.appendChild(fill);

          const countNode = document.createElement("span");
          countNode.className = "zoda-pdp__review-overview-count";
          countNode.textContent = String(count);

          row.append(rowStars, track, countNode);
          overviewBars.appendChild(row);
        }
      };
      const renderEmptyState = () => {
        reviewSection.hidden = false;
        fallback.hidden = false;
        if (nativeWidget.dataset.zodaPdpReviewFormOpen !== "true") setNativeWidgetState("closed");
        if (writeReviewButton) writeReviewButton.hidden = false;
        renderOverview(0, 0, { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 });
        if (reviewFilter) reviewFilter.hidden = true;
        if (reviewControls) reviewControls.hidden = true;

        if (nativeBadge) nativeBadge.hidden = true;
        if (reviewStub) reviewStub.hidden = false;
        if (summaryFallback) {
          summaryFallback.hidden = false;
          summaryFallback.textContent = "Be the first to write a review";
          summaryFallback.onclick = (event) => {
            event.preventDefault();
            revealNativeReviewForm();
          };
        }

        const empty = document.createElement("div");
        empty.className = "zoda-pdp__review-empty";

        const title = document.createElement("h3");
        title.className = "zoda-pdp__review-empty-title";
        title.textContent = "Be the first to write a review";

        const copy = document.createElement("p");
        copy.className = "zoda-pdp__review-empty-copy";
        copy.textContent = "Tell other athletes how this product performed for you.";

        empty.append(title, copy);
        fallback.replaceChildren(empty);
      };
      const reviewNodes = getVisibleReviewNodes(source);
      const ratingReviewNodes = [...source.querySelectorAll(".jdgm-rev")].filter((review) => getReviewRating(review));
      const reviewCount = Number(source.dataset.numberOfReviews || ratingReviewNodes.length || reviewNodes.length || 0);
      const ratingCounts = getRatingCounts(ratingReviewNodes);
      const calculatedRatingTotal = Object.entries(ratingCounts).reduce((total, [rating, count]) => total + Number(rating) * count, 0);
      const calculatedReviewTotal = Object.values(ratingCounts).reduce((total, count) => total + count, 0);
      const averageRating = Number(source.dataset.averageRating || (calculatedReviewTotal ? calculatedRatingTotal / calculatedReviewTotal : 0));

      if (!reviewCount || !reviewNodes.length) {
        renderEmptyState();
        return;
      }

      reviewSection.hidden = false;
      fallback.hidden = false;
      if (nativeWidget.dataset.zodaPdpReviewFormOpen !== "true") setNativeWidgetState("closed");
      if (writeReviewButton) writeReviewButton.hidden = false;
      renderOverview(reviewCount, averageRating, ratingCounts);

      if (nativeBadge) nativeBadge.hidden = true;
      if (reviewStub) reviewStub.hidden = false;
      if (summaryFallback) {
        summaryFallback.hidden = false;
        summaryFallback.onclick = null;
        summaryFallback.innerHTML = "";

        const stars = document.createElement("span");
        stars.className = "zoda-pdp__review-summary-stars";
        stars.setAttribute("aria-hidden", "true");

        for (let index = 1; index <= 5; index += 1) {
          const star = document.createElement("span");
          star.className = index <= Math.round(averageRating || 5) ? "is-filled" : "";
          star.textContent = "★";
          stars.appendChild(star);
        }

        const text = document.createElement("span");
        text.textContent = `${averageRating ? averageRating.toFixed(1) : "5.0"} / 5 (${reviewCount} ${reviewCount === 1 ? "review" : "reviews"})`;

        summaryFallback.append(stars, text);
      }

      const createReviewCard = (review) => {
        const card = document.createElement("article");
        card.className = "zoda-pdp__review-card";

        const rating = Number(review.querySelector(".jdgm-rev__rating")?.dataset.score || 5);
        const stars = document.createElement("div");
        stars.className = "zoda-pdp__review-card-stars";
        stars.setAttribute("aria-label", `${rating} out of 5 stars`);

        for (let index = 1; index <= 5; index += 1) {
          const star = document.createElement("span");
          star.className = index <= Math.round(rating) ? "is-filled" : "";
          star.textContent = "★";
          stars.appendChild(star);
        }
        card.appendChild(stars);

        const body = document.createElement("p");
        body.className = "zoda-pdp__review-card-copy";
        body.textContent = normalize(review.querySelector(".jdgm-rev__body")?.textContent);
        card.appendChild(body);

        const mediaSources = [...review.querySelectorAll(".jdgm-rev__pic-img")]
          .map((image) => image.getAttribute("data-src") || image.getAttribute("src") || "")
          .filter(Boolean)
          .filter((imageSrc, index, sources) => sources.indexOf(imageSrc) === index);

        if (mediaSources.length) {
          const media = document.createElement("div");
          media.className = "zoda-pdp__review-card-media";

          mediaSources.forEach((imageSrc) => {
            const img = document.createElement("img");
            img.src = imageSrc;
            img.alt = "Customer review photo";
            img.loading = "lazy";
            media.appendChild(img);
          });

          card.appendChild(media);
        }

        const meta = document.createElement("div");
        meta.className = "zoda-pdp__review-card-meta";

        const author = document.createElement("strong");
        author.textContent = normalize(review.querySelector(".jdgm-rev__author")?.textContent) || "Verified customer";
        meta.appendChild(author);

        if (review.dataset.verifiedBuyer === "true") {
          const verified = document.createElement("span");
          verified.textContent = "Verified";
          meta.appendChild(verified);
        }

        card.appendChild(meta);
        return card;
      };
      const renderReviewCards = (reviews) => {
        const state = getReviewUiState();
        state.reviews = reviews;

        const filteredReviews = sortReviewNodes(getFilteredReviewNodes(reviews, state.rating), state.sort);
        const totalPages = Math.max(1, Math.ceil(filteredReviews.length / ZODA_PDP_REVIEW_PAGE_SIZE));
        state.page = Math.min(Math.max(Number(state.page) || 1, 1), totalPages);

        const pageStart = (state.page - 1) * ZODA_PDP_REVIEW_PAGE_SIZE;
        const pageReviews = filteredReviews.slice(pageStart, pageStart + ZODA_PDP_REVIEW_PAGE_SIZE);

        if (!pageReviews.length) {
          const empty = document.createElement("div");
          empty.className = "zoda-pdp__review-empty";

          const title = document.createElement("h3");
          title.className = "zoda-pdp__review-empty-title";
          title.textContent = "No reviews match this filter";

          const copy = document.createElement("p");
          copy.className = "zoda-pdp__review-empty-copy";
          copy.textContent = "Choose another rating to keep browsing product reviews.";

          empty.append(title, copy);
          fallback.replaceChildren(empty);
        } else {
          fallback.replaceChildren(...pageReviews.map(createReviewCard));
        }

        renderReviewFilterControls(reviews);
        renderReviewPagination(totalPages, state.page, filteredReviews.length);
      };

      renderReviewCards(reviewNodes);
      injectReviewSchema(reviewNodes, reviewCount, averageRating);

      if (reviewCount > reviewNodes.length) {
        collectAllReviewNodes(reviewNodes, reviewCount).then((allReviewNodes) => {
          if (allReviewNodes.length <= reviewNodes.length) return;
          renderReviewCards(allReviewNodes);
          injectReviewSchema(allReviewNodes, reviewCount, averageRating);
        });
      }
    });
  };

  const runProductReviewFallbacks = () => {
    renderProductReviewFallbacks();
    window.setTimeout(renderProductReviewFallbacks, 900);
    window.setTimeout(renderProductReviewFallbacks, 2200);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runProductReviewFallbacks, { once: true });
  } else {
    runProductReviewFallbacks();
  }

  const sections = document.querySelectorAll("[data-zoda-pdp-section]");

  sections.forEach((section) => {
    const dataNode = section.querySelector("[data-zoda-pdp-json]");
    if (!dataNode) return;

    let state;
    try {
      state = JSON.parse(dataNode.textContent || "{}");
    } catch {
      return;
    }

    const variants = Array.isArray(state.variants) ? state.variants : [];
    const selected = Array.isArray(state.selectedOptions) ? [...state.selectedOptions] : [];
    const addButton = section.querySelector("[data-zoda-pdp-add]");
    const addLabel = section.querySelector("[data-zoda-pdp-add-label]");
    const price = section.querySelector("[data-zoda-pdp-price]");
    const compare = section.querySelector("[data-zoda-pdp-compare]");
    const installments = section.querySelector("[data-zoda-pdp-installments]");
    const primaryImage = section.querySelector("[data-zoda-pdp-primary-image]");

    const findVariant = () =>
      variants.find((variant) => variant.options.every((option, index) => selected[index] === option)) ||
      null;

    const findVariantForOption = (index, value) =>
      variants.find((variant) => {
        if (!variant.available || variant.options[index] !== value) return false;

        return variant.options.every((option, optionIndex) => {
          if (optionIndex === index) return true;
          return !selected[optionIndex] || selected[optionIndex] === option;
        });
      }) ||
      variants.find((variant) => variant.available && variant.options[index] === value) ||
      variants.find((variant) => variant.options[index] === value) ||
      null;

    const syncSelectedToVariant = (variant) => {
      if (!variant?.options) return;
      variant.options.forEach((option, index) => {
        selected[index] = option;
      });
    };

    const updateIcons = () => {
      section.querySelectorAll("[data-zoda-pdp-accordion]").forEach((accordion) => {
        const button = accordion.querySelector(".zoda-pdp-acc__summary");
        const svg = button?.querySelector("svg");
        const icon = button?.querySelector("path");
        const expanded = button?.getAttribute("aria-expanded") === "true";
        if (svg) {
          svg.classList.toggle("lucide-minus", expanded);
          svg.classList.toggle("lucide-plus", !expanded);
        }
        if (icon) icon.setAttribute("d", expanded ? "M5 12h14" : "M12 5v14M5 12h14");
      });
    };

    const setAccordionState = (accordion, expanded) => {
      const summary = accordion?.querySelector(".zoda-pdp-acc__summary");
      const content = accordion?.querySelector(".zoda-pdp-acc__content");
      if (!summary || !content) return;
      summary.setAttribute("aria-expanded", expanded ? "true" : "false");
      content.hidden = !expanded;
    };

    const openSizeGuide = (scroll = true) => {
      const accordion = section.querySelector("#zoda-size-fit");
      if (!accordion) return false;
      setAccordionState(accordion, true);
      updateIcons();
      if (scroll) {
        window.requestAnimationFrame(() => {
          accordion.scrollIntoView({ behavior: "smooth", block: "center" });
        });
      }
      return true;
    };

    const openFabricDetails = (scroll = true) => {
      const accordion = section.querySelector("#zoda-fabric-details");
      if (!accordion) return false;
      setAccordionState(accordion, true);
      updateIcons();
      if (scroll) {
        window.requestAnimationFrame(() => {
          accordion.scrollIntoView({ behavior: "smooth", block: "center" });
        });
      }
      return true;
    };

    const handlePdpHash = () => {
      if (window.location.hash === "#zoda-size-fit") openSizeGuide(true);
      if (window.location.hash === "#zoda-fabric-details") openFabricDetails(true);
    };

    const refresh = () => {
      section.querySelectorAll("[data-zoda-pdp-option]").forEach((button) => {
        const index = Number(button.getAttribute("data-option-index") || "0");
        const value = button.getAttribute("data-option-value") || "";
        const isActive = selected[index] === value;
        const possible = variants.some((variant) => variant.available && variant.options[index] === value);

        if (button.classList.contains("zoda-pdp__swatch")) {
          button.classList.toggle("zoda-pdp__swatch--active", isActive);
        }
        if (button.classList.contains("zoda-pdp__variant")) {
          button.classList.toggle("zoda-pdp__variant--active", isActive);
        }
        button.setAttribute("aria-pressed", isActive ? "true" : "false");
        button.disabled = !possible;
      });

      selected.forEach((value, index) => {
        const label = section.querySelector(`[data-zoda-pdp-option-label="${index}"]`);
        if (label) label.textContent = `- ${value}`;
      });

      const variant = findVariant();
      if (!variant) {
        if (addButton) {
          addButton.removeAttribute("data-variant-id");
          addButton.disabled = true;
        }
        if (addLabel) addLabel.textContent = "Unavailable";
        return;
      }

      if (addButton) {
        addButton.setAttribute("data-variant-id", String(variant.id));
        addButton.disabled = !variant.available;
      }
      if (addLabel) addLabel.textContent = variant.available ? "Add to bag" : "Sold out";
      if (price) price.textContent = variant.price;
      if (compare) {
        compare.textContent = variant.compareAtPrice || "";
        compare.hidden = !variant.compareAtPrice;
      }
      if (installments) installments.textContent = `or 4 payments of ${variant.installments}`;
      if (primaryImage && variant.image) {
        primaryImage.setAttribute("src", variant.image);
        primaryImage.removeAttribute("srcset");
      }

      if (variant.url) {
        window.history.replaceState({}, "", `${variant.url}${window.location.hash || ""}`);
      }
    };

    section.addEventListener("click", (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const option = target.closest("[data-zoda-pdp-option]");
      if (option) {
        event.preventDefault();
        const index = Number(option.getAttribute("data-option-index") || "0");
        selected[index] = option.getAttribute("data-option-value") || "";
        const selectedVariant = findVariant() || findVariantForOption(index, selected[index]);
        syncSelectedToVariant(selectedVariant);
        refresh();
        return;
      }

      const sizeGuideLink = target.closest('a[href="#zoda-size-fit"]');
      if (sizeGuideLink) {
        event.preventDefault();
        window.history.pushState({}, "", "#zoda-size-fit");
        openSizeGuide(true);
        return;
      }

      const fabricDetailsLink = target.closest('a[href="#zoda-fabric-details"], [data-zoda-pdp-fabric-link]');
      if (fabricDetailsLink) {
        event.preventDefault();
        window.history.pushState({}, "", "#zoda-fabric-details");
        openFabricDetails(true);
        return;
      }

      const summary = target.closest(".zoda-pdp-acc__summary");
      if (summary) {
        event.preventDefault();
        const accordion = summary.closest("[data-zoda-pdp-accordion]");
        const content = accordion?.querySelector(".zoda-pdp-acc__content");
        const expanded = summary.getAttribute("aria-expanded") === "true";
        setAccordionState(accordion, !expanded);
        updateIcons();
        return;
      }

      const toggle = target.closest("[data-zoda-pdp-desc-toggle]");
      if (toggle) {
        event.preventDefault();
        const desc = section.querySelector("[data-zoda-pdp-desc]");
        const clamped = desc?.classList.toggle("is-clamped");
        toggle.textContent = clamped ? "See more" : "See less";
      }
    });

    section.querySelector("[data-zoda-pdp-strip-prev]")?.addEventListener("click", () => {
      const strip = section.querySelector("[data-zoda-pdp-strip]");
      const item = strip?.querySelector(".zoda-pdp__strip-item");
      strip?.scrollBy({ left: -(item?.clientWidth || strip.clientWidth), behavior: "smooth" });
    });

    section.querySelector("[data-zoda-pdp-strip-next]")?.addEventListener("click", () => {
      const strip = section.querySelector("[data-zoda-pdp-strip]");
      const item = strip?.querySelector(".zoda-pdp__strip-item");
      strip?.scrollBy({ left: item?.clientWidth || strip.clientWidth, behavior: "smooth" });
    });

    updateIcons();
    refresh();
    window.addEventListener("hashchange", handlePdpHash);
    window.requestAnimationFrame(handlePdpHash);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
